import { render, staticRenderFns } from "./fleet.cattle.io.gitrepo.vue?vue&type=template&id=1b4f83e6&"
import script from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js&"
export * from "./fleet.cattle.io.gitrepo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports